import { TranslationFunction } from '@/types';

export const infoSensor = [
  {
    label: 'serialNumber',
    type: 'text',
    name: 'sn',
    validation: 'required'
  },
  {
    label: 'id',
    type: 'text',
    name: 'id',
    validation: 'required'
  },
  {
    label: 'name',
    type: 'text',
    name: 'name',
    validation: 'required'
  },
  {
    label: 'description',
    type: 'text',
    name: 'description',
    validation: 'required'
  }
];

export const sensorTypeOptions = ($t: TranslationFunction) => [
  {
    value: 'room',
    label: $t('room')
  },
  {
    value: 'fridge',
    label: $t('fridge')
  },
  {
    value: 'individual',
    label: $t('individual')
  }
];

export const SENSOR_TYPE_RANGES: Record<string, { max: number; min: number }> = {
  fridge: { max: 8, min: 2 },
  room: { max: 25, min: 15 }
};

export const normalizeSensorData = (data: any) => {
  if (!data) return data;
  return {
    ...data,
    type: data.type || 'individual'
  };
};
